import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Category } from '../models/calendar.model';
import { WelcomeApi } from './welcome-api.base';

@Injectable()
export class CategoriesService extends WelcomeApi<Category> {
  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('v1/categories', http, roleService, uxService);
  }
}
